<script lang="ts">
    import { users } from "../../../store"

    export let image: Media

    function formatDate(date: Date): string {
        const day = date.getDate().toString().padStart(2, "0")
        const month = (date.getMonth() + 1).toString().padStart(2, "0")
        const year = date.getFullYear()
        const hours = date.getHours().toString().padStart(2, "0")
        const minutes = date.getMinutes().toString().padStart(2, "0")
        const seconds = date.getSeconds().toString().padStart(2, "0")
        return `${day}.${month}.${year} | ${hours}:${minutes}:${seconds}`
    }
    $: data = image
        ? {
              Aufnahme: formatDate(new Date(image.shotAt)),
              Fahrer: $users[image.author ? image?.author?.id : null]?.username,
              Übertragung: formatDate(new Date(image.uploadedAt)),
              "Geo-Koordinaten": `Breite: ${image.location ? image.location.latitude : "Unbekannt"}<br /><br />Länge: ${
                  image.location ? image.location.longitude : "Unbekannt"
              }`,
          }
        : {}
</script>

<div class="image-meta-data">
    {#each Object.keys(data) as key}
        <div
            class="data-row"
            style="{key.includes('Geo') ? 'flex-direction: column; align-items: flex-start' : ''}"
        >
            <p class="key">{key}:</p>

            <p class="value small-font">{@html data[key]}</p>
        </div>
    {/each}
</div>

<style lang="less">
    @import "../../../../../assets/variables.less";
    .image-meta-data {
        display: flex;
        flex-grow: 1;
        padding: 6px 0.6rem;
        @media @mobile {
            padding: 6px 0px;
        }
        flex-direction: column;
        gap: 6px;
        .data-row {
            display: flex;
            gap: 0.5rem;
            flex-wrap: wrap;
            align-items: center;
            border-bottom: 1px solid var(--grey-200);
            padding-bottom: 6px;
            @media @mobile {
                flex-direction: column;
                align-items: flex-start;
            }
            &:last-child {
                border-bottom: 0px;
            }

            .key {
                font-family: var(--content-label-small-font-family);
                font-size: var(--content-label-small-font-size);
                line-height: var(--content-label-small-font-size);
                font-weight: var(--content-label-small-font-weight);
                font-style: var(--content-label-small-font-style);
                color: var(--text-100);
                text-transform: uppercase;
            }
            .value {
                white-space: nowrap;
                color: var(--text-100);
            }
        }
    }
</style>
